import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz37 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel38'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel36'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Maximum run in cricket</h1>
    
    <div class="text">
        <p><b>Question: </b>In a <b><i>one day international cricket match</i></b>, considering no extras(no wides, no
            ‘no’ balls, etc.) and no overthrows.</p>
        <p>What is the maximum number of runs that a batsman can score in an ideal case ?</p>
        <p>Note:”Here we assume ideal and little practical scenario. We assume that batsman can not run for more than 3
            runs in a ball, as otherwise there is no limit, he can run infinite runs(theoretically) in a ball, as far as
            opposite team does not catch the ball.”</p>
        <p><br/><br/><br/><br/><br/><br/><br/></p>
        <div class="containers">
        <p><b>Answer:</b></p><br/>
      
        <p><b>49</b>*(6*5+3)+(6*6)= <b>1653</b></p>
        <p><b>From Over 1 to 49:</b></p>
        <p>1st ball:- 6 runs(hit six)</p>
        <p>2nd ball:- 6 runs(hit six)</p>
        <p>3rd ball:- 6 runs(hit six)</p>
        <p>4th ball:- 6 runs(hit six)</p>
        <p>5th ball:- 6 runs(hit six)</p>
        <p>6th ball:- 3 runs(took 3 runs between the wickets and take back the strike)</p>
        <p>= &gt;49*(6*5+3)</p>
        <p><b>50th Over:</b></p>
        <p>Hit six sixes in a row.</p>
        <p>= &gt;6*6</p>
       </div>
    </div>
</article>
        </div>
    )
}

export default Puz37
